
import { defineComponent, PropType } from 'vue';
import type { Policy } from '@white-label-types/parking-booking';
import type { Partners } from '@white-label-types/partners-api';

import ToggleContent from '../toggle-content/toggle-content.vue';
import { getDomainUrl, DOMAINS_NAMES } from '@white-label-helper/switch-app';
import { getAppVariable } from '@white-label-helper/get-app-variable';

export default defineComponent({
  name: 'BTicketPolicies',

  components: {
    ToggleContent,
  },

  props: {
    cancellationPolicies: {
      type: Array as PropType<Policy[]>,
      default: () => [],
    },

    amendmentPolicies: {
      type: Array as PropType<Policy[]>,
      default: () => [],
    },

    isParkingProduct: {
      type: Boolean,
      default: false,
    },

    isBundleProduct: {
      type: Boolean,
      default: false,
    },

    bundleName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      termsURL: undefined,
    };
  },

  computed: {
    hasCancellationPolicies(): boolean {
      return !!this.cancellationPolicies.length;
    },

    hasAmendmentPolicies(): boolean {
      return !!this.amendmentPolicies.length;
    },

    hasCancellationOrAmendmentPolicies(): boolean {
      return this.hasAmendmentPolicies || this.hasCancellationPolicies;
    },
    text3WithLink(): string {
      const linkText = this.$t('cancellationAndAmendment.travelInsurance.battleface.text4');
      const linkHtml = `<a href="${this.termsURL}" target="_blank" rel="noopener noreferrer">${linkText}</a>`;
      const text3 = this.$t('cancellationAndAmendment.travelInsurance.battleface.text3') as string;
      return text3.replace('{link}', linkHtml);
    }
  },

  mounted() {
    const { terms_and_conditions } = getAppVariable('page_texts') as Partners['page_texts'];
    const language = this.$i18n.locale;

    const isLinkType = terms_and_conditions.type === 'link';
    const linkValue = isLinkType && terms_and_conditions.value[language];

    this.termsURL = linkValue || `${getDomainUrl(DOMAINS_NAMES.ECOMMERCE)}/terms-and-conditions/`;
  },
});
